import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import 'app/modules/Dashboard Cognito/PersonalInformation.scss';
import Alert from 'app/modules/Shared/Alert Cognito/Alert';
import { faEye, faPenAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditNamePopup from 'app/modules/Dashboard Cognito/EditNamePopup';
import EditEmailPopup from 'app/modules/Dashboard Cognito/EditEmailPopup';
import EditMobileNumberPopup from 'app/modules/Dashboard Cognito/EditMobileNumberPopup';
import VerifyMobileNumberPopup from 'app/modules/Dashboard Cognito/VerifyMobileNumberPopup';
import VerifyEmailPopup from 'app/modules/Dashboard Cognito/VerifyEmailPopup';
import http from 'api cognito/http-request';
import { formatPhoneNumber } from 'utils/common cognito';
import Cookies from 'js-cookie';
import { clearCookies } from 'utils/common cognito';
import ReactGA from 'react-ga';
import { getAdminUser } from 'api cognito/aws4_module';

class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertText: '',
      alertStatus: '',
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      confirmEmail: '',
      showEditPopup: false,
      dobHidden: true,
      phoneNumberHidden: true,
      userDetails: props.userDetails ? props.userDetails : '',
      showEmailPopup: false,
      showMobileNumberPopup: false,
      verifyMobileNumberPopup: false,
      emailVerificationPopup: false,
      verifyEmailPopup: false,
    };
  }

  getUserDetails = (token) => {
    http(
      {
        url: '/amazonaws',
        data: {
          AccessToken: token,
        },
        method: 'POST',
      },
      {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-Amz-Target': 'AWSCognitoIdentityProviderService.GetUser',
      }
    ).then((res) => {
      if (res.data && res.status === 200) {
        const { setUserDetails } = this.props;
        let cloneData = _.cloneDeep(res.data);
        let data = res.data;

        setUserDetails(data);

        this.setState({
          userDetails: res.data,
        });
      } else if (
        res.status === 400 &&
        res.data.__type === 'NotAuthorizedException'
      ) {
        clearCookies();
        window.location.href = '/';
      }
    });
  };

  getAdminUser = async () => {
    let username = Cookies.get('userName');
    const { setUserDetails } = this.props;
    var output = await getAdminUser(username);

    if (output) {
      setUserDetails(output);
      this.setState({
        userDetails: output,
      });
    }
  };

  componentDidMount() {
    const { userDetails } = this.props;

    window.scrollTo(0, 0);

    let token = Cookies.get('dataStoreToken');
    let code = Cookies.get('code');

    if (code) {
      this.getAdminUser(Cookies.get('userName'));
    } else {
      if (token && !code) {
        this.getUserDetails(token);
      }
    }
  }

  onEditSuccessHandler = (status) => {
    const alertText =
      status === 'success'
        ? 'pages.editName.successMsg'
        : 'pages.editNamePopup.errorMsg';
    if (status === 'success') {
      // const { getUpdatedName } = this.props;
      // getUpdatedName();
      // let token = localStorage.getItem('dataStoreToken');
      let token = Cookies.get('dataStoreToken');
      // let id = localStorage.getItem('user_id');
      //let id = Cookies.get('user_id');
      let code = Cookies.get('code');
      if (code) {
        this.getAdminUser();
      } else if (token && !code) {
        this.getUserDetails(token);
      }
    }
    this.setState(
      {
        showEditPopup: false,
        alertStatus: status,
        alertText,
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: '',
          });
        }, 5000);
      }
    );
  };

  onEditMobileNumberSuccessHandler = (status) => {
    const alertText =
      status === 'success'
        ? 'pages.editNumberPopup.mobileChangeSuccessMsg'
        : 'pages.editNumberPopup.mobileChangeErrorMsg';
    if (status === 'success') {
      let token = Cookies.get('dataStoreToken');

      if (token) {
        this.getUserDetails(token);
      }
    }
    this.setState(
      {
        showMobileNumberPopup: false,
        alertStatus: status,
        alertText,
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: '',
          });
        }, 5000);
      }
    );
  };

  onVerifyMobileNumberSuccessHandler = (status) => {
    const alertText =
      status === 'success'
        ? 'pages.editNumberPopup.mobileChangeSuccessMsg'
        : 'pages.editNumberPopup.mobileChangeErrorMsg';
    if (status === 'success') {
      let token = Cookies.get('dataStoreToken');

      if (token) {
        this.getUserDetails(token);
      }
    }
    this.setState(
      {
        verifyMobileNumberPopup: false,
        alertStatus: status,
        alertText,
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: '',
          });
        }, 5000);
      }
    );
  };

  onVerifyEmailSuccessHandler = (status) => {
    const alertText =
      status === 'success'
        ? 'pages.editEmail.emailChangeSuccessMsg'
        : 'pages.editNamePopup.errorMsg';
    if (status === 'success') {
      let token = Cookies.get('dataStoreToken');

      if (token) {
        this.getUserDetails(token);
      }
    }
    this.setState(
      {
        verifyEmailPopup: false,
        alertStatus: status,
        alertText,
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: '',
          });
        }, 5000);
      }
    );
  };

  onEditEmailSuccessHandler = (status) => {
    const alertText =
      status === 'success'
        ? 'pages.editEmail.emailChangeSuccessMsg'
        : 'pages.editNamePopup.errorMsg';

    if (status === 'success') {
      let token = Cookies.get('dataStoreToken');

      if (token) {
        this.getUserDetails(token);
      }
    }
    this.setState(
      {
        showEmailPopup: false,
        alertStatus: status,
        alertText,
      },
      () => {
        setTimeout(() => {
          this.setState({
            alertText: '',
          });
        }, 5000);
      }
    );
  };
  onErrorEmailSuccessHandler = (status, message) => {
    let alertText = '';
    if (message === 'SMTP_ERROR') {
      alertText = 'pages.editEmail.smtpError';
    } else if (message === 'MAX_RESEND_EXCEEDED') {
      alertText = 'errors.maxResendAttempt';
    } else if (message === 'MAX_RETRY_EXCEEDED') {
      alertText = 'errors.maxVerifyAttempt';
    } else if (message === 'TWILIO_ERROR') {
      alertText = 'errors.twilioError';
    } else if (message === 'LimitExceededException') {
      alertText = 'errors.maxResendAttempt';
    }
    if (status === 'error') {
      this.setState(
        {
          alertStatus: status,
          showEmailPopup: false,
          showEditPopup: false,
          showMobileNumberPopup: false,
          verifyEmailPopup: false,
          alertText,
        },
        () => {
          setTimeout(() => {
            this.setState({
              alertText: '',
            });
          }, 5000);
        }
      );
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    }
  };

  showEditPopup = () => {
    this.setState({
      showEditPopup: true,
    });
  };

  showEmailPopup = () => {
    ReactGA.event({
      category: 'Email Update',
      action: 'Email Update Triggered: Email Update Button Clicked',
    });
    this.setState({
      showEmailPopup: true,
    });
  };

  showMobileNumberPopup = () => {
    ReactGA.event({
      category: 'Mobile Update',
      action: 'Mobile Update Button Clicked.',
    });
    this.setState({
      showMobileNumberPopup: true,
    });
  };

  verifyMobileNumberPopup = () => {
    this.setState({
      verifyMobileNumberPopup: true,
    });
  };
  verifyEmailPopup = () => {
    this.setState({
      verifyEmailPopup: true,
    });
  };

  codeText = (text) => {
    return text.replace(/.(?=.{0})/g, '*');
  };

  phoneNumberHideToggler = () => {
    this.setState((prev) => ({
      phoneNumberHidden: !prev.phoneNumberHidden,
    }));
  };

  render() {
    const { t } = this.props;
    const {
      alertText,
      alertStatus,
      showEditPopup,
      userDetails,
      showEmailPopup,
      showMobileNumberPopup,
      verifyMobileNumberPopup,

      verifyEmailPopup,
    } = this.state;
    const code = Cookies.get('code');
    return (
      <div>
        {alertText && (
          <Alert
            alertText={alertText}
            className={alertStatus}
            onAlertClose={() => {
              this.setState({
                alertText: '',
              });
            }}
          />
        )}

        {showEditPopup && (
          <EditNamePopup
            onClose={() => {
              this.setState({ showEditPopup: false });
            }}
            onEditSuccessHandler={this.onEditSuccessHandler}
            givenName={
              userDetails.UserAttributes
                ? userDetails.UserAttributes[7].Value
                : ''
            }
            sn={
              userDetails.UserAttributes
                ? userDetails.UserAttributes[4].Value
                : ''
            }
          />
        )}

        {showEmailPopup && (
          <EditEmailPopup
            onClose={() => {
              this.setState({ showEmailPopup: false });
            }}
            onEditEmailSuccessHandler={this.onEditEmailSuccessHandler}
            givenName={userDetails.givenName}
            sn={userDetails.sn}
            mail={
              userDetails.UserAttributes
                ? userDetails.UserAttributes[
                    userDetails.UserAttributes.length - 1
                  ].Value
                : ''
            }
            emailVerified={
              userDetails.UserAttributes
                ? userDetails.UserAttributes[2].Value
                : ''
            }
            onErrorEmailSuccessHandler={this.onErrorEmailSuccessHandler}
          />
        )}
        {showMobileNumberPopup && (
          <EditMobileNumberPopup
            onClose={() => {
              this.setState({ showMobileNumberPopup: false });
            }}
            onEditMobileNumberSuccessHandler={
              this.onEditMobileNumberSuccessHandler
            }
            telephoneNumber={userDetails.UserAttributes[6].Value}
            onErrorEmailSuccessHandler={this.onErrorEmailSuccessHandler}
            //updateVerifyFlag={this.updateVerifyFlag}
          />
        )}
        {verifyMobileNumberPopup && (
          <VerifyMobileNumberPopup
            onClose={() => {
              this.setState({ verifyMobileNumberPopup: false });
            }}
            onVerifyMobileNumberSuccessHandler={
              this.onVerifyMobileNumberSuccessHandler
            }
            telephoneNumber={userDetails.UserAttributes[6].Value}
            onErrorEmailSuccessHandler={this.onErrorEmailSuccessHandler}
          />
        )}
        {verifyEmailPopup && (
          <VerifyEmailPopup
            onClose={() => {
              this.setState({ verifyEmailPopup: false });
            }}
            onVerifyEmailSuccessHandler={this.onVerifyEmailSuccessHandler}
            givenName={userDetails.givenName}
            sn={userDetails.sn}
            mail={
              userDetails.UserAttributes
                ? userDetails.UserAttributes[
                    userDetails.UserAttributes.length - 1
                  ].Value
                : ''
            }
            onErrorEmailSuccessHandler={this.onErrorEmailSuccessHandler}
          />
        )}
        <div className="personal-information">
          <h1 className="pb-3">{t('pages.personalInformation.title')}</h1>
          <div className="personal-information__container">
            <div className="col-sm-4 bold">
              {t('pages.personalInformation.fullName')}
            </div>

            <div className="col-sm-6">
              {userDetails.UserAttributes
                ? userDetails.UserAttributes[7].Value
                : ''}{' '}
              {userDetails.UserAttributes
                ? userDetails.UserAttributes[4].Value
                : ''}
            </div>
            <div
              style={
                code ? { 'pointer-events': 'none', color: 'lightgrey' } : {}
              }
              className="col-sm-2 text-right"
              onClick={() => {
                this.showEditPopup();
              }}
              role="button"
              tabIndex={0}
              aria-label="Edit Full Name"
              onKeyPress={() => {
                this.showEditPopup();
              }}
            >
              <FontAwesomeIcon icon={faPenAlt} />
            </div>
          </div>
          <div className="personal-information__container">
            <div className="col-sm-4 bold">
              {t('pages.personalInformation.Email')}
            </div>
            <div className="col-sm-5 text-left">
              {userDetails.UserAttributes
                ? userDetails.UserAttributes[
                    userDetails.UserAttributes.length - 1
                  ].Value
                : ''}
            </div>
            {userDetails.UserAttributes[2].Value == 'false' && (
              <div
                style={
                  code ? { 'pointer-events': 'none', color: 'lightgrey' } : {}
                }
                className="col-sm-2 text-right"
                onClick={() => {
                  this.verifyEmailPopup();
                  this.setState({ emailVerificationPopup: true });
                }}
                role="button"
                aria-label="Edit Mail"
                tabIndex={0}
                onKeyPress={() => {
                  this.verifyEmailPopup();
                }}
              >
                <span style={code ? { color: 'grey' } : { color: 'red' }}>
                  {t('pages.personalInformation.verify')}
                </span>
              </div>
            )}
            <div
              style={
                code ? { 'pointer-events': 'none', color: 'lightgrey' } : {}
              }
              className={
                userDetails.UserAttributes[2].Value == 'false'
                  ? 'col-sm-1 text-right'
                  : 'ml-sm-1 col-sm-3 text-right'
              }
              onClick={() => {
                this.showEmailPopup();
              }}
              role="button"
              aria-label="Edit Mail"
              tabIndex={0}
              onKeyPress={() => {
                this.showEmailPopup();
              }}
            >
              <FontAwesomeIcon icon={faPenAlt} />
            </div>
          </div>
          <div className="personal-information__container">
            <div className="col-sm-4 bold">
              {t('pages.personalInformation.PhoneNumber')}
            </div>
            <div className="col-sm-5 text-left">
              {this.state.phoneNumberHidden
                ? this.codeText(t('pages.personalInformation.Phone'))
                : userDetails.UserAttributes[6].Value
                ? `${formatPhoneNumber(
                    userDetails.UserAttributes[6].Value.replace('+1', '')
                  )}`
                : ''}
            </div>
            <div className="text-right col-sm-1 ">
              <button
                className="bg-transparent border-0"
                aria-label="Show phone number"
                onClick={this.phoneNumberHideToggler}
              >
                <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
              </button>
            </div>
            {userDetails.UserAttributes[5].Value == 'false' && (
              <div
                style={
                  code ? { 'pointer-events': 'none', color: 'lightgrey' } : {}
                }
                className="col-sm-1 text-right"
                onClick={() => {
                  this.verifyMobileNumberPopup();
                  this.setState({ mobileVerificationPopup: true });
                }}
                role="button"
                tabIndex={0}
                onKeyPress={() => {
                  this.verifyMobileNumberPopup();
                }}
                aria-label="Edit phone number"
              >
                <span style={code ? { color: 'grey' } : { color: 'red' }}>
                  {t('pages.personalInformation.verify')}
                </span>
              </div>
            )}
            {
              <div
                style={
                  code ? { 'pointer-events': 'none', color: 'lightgrey' } : {}
                }
                className={
                  userDetails.UserAttributes[5].Value == 'false'
                    ? 'text-right col-sm-1 '
                    : 'ml-sm-1 col-sm-2 text-right'
                }
                onClick={() => {
                  this.showMobileNumberPopup();
                }}
                role="button"
                tabIndex={0}
                onKeyPress={() => {
                  this.showMobileNumberPopup();
                }}
                aria-label="Edit phone number"
              >
                <FontAwesomeIcon icon={faPenAlt} role="img" />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}
PersonalInformation.propTypes = {
  getUpdatedName: PropTypes.func.isRequired,
  setUserDetails: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  userDetails: PropTypes.object,
};
PersonalInformation.defaultProps = {
  userDetails: {
    userName: '',
    mail: '',
    telephoneNumber: '',
    givenName: '',
    sn: '',
  },
};
export default withTranslation()(PersonalInformation);
